// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ObjectList_wrapper__1agaN"};